import React from "react";

export default function Bold({ children }) {
  return <span className="bold">{children}</span>;
}
